import React, { Suspense, lazy }  from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WelcomePage from './components/WelcomePage';
import ResultsPage from './components/ResultsPage';
import { Analytics } from '@vercel/analytics/react';
import './App.css';

function App() {
  const QuizPage = lazy(() => import('./components/QuizPage'));

  return (
  <>
    <Router>
      <Suspense fallback={<div className="loading-screen">Loading...</div>}>
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path='/results' element={<ResultsPage />} />
        </Routes>
        <Analytics />
      </Suspense>
    </Router>
  </>
  );
}

export default App;